import { render, staticRenderFns } from "./IconProfileRed.vue?vue&type=template&id=7b838c69&functional=true&"
import script from "./IconProfileRed.vue?vue&type=script&lang=js&"
export * from "./IconProfileRed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports